import { render, staticRenderFns } from "./orderCenterList.vue?vue&type=template&id=6ff9a452&scoped=true"
import script from "./orderCenterList.vue?vue&type=script&lang=js"
export * from "./orderCenterList.vue?vue&type=script&lang=js"
import style0 from "./orderCenterList.vue?vue&type=style&index=0&id=6ff9a452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff9a452",
  null
  
)

export default component.exports